<script setup>
/* eslint-disable */
import { ref, watch, computed } from "vue"
import { useRouter } from "vue-router";
import { useOddsStore } from '@/stores/odds';
import { BetSlip } from '@/stores/BetSlip';
import { EditBetSlip } from "@/stores/edit_betslip";
import { useBetBoosterStore } from '@/stores/bet_booster';
import menuIcons from '@/assets/svgs/NotificationMenu.json'
import commonSvgs from '@/assets/svgs/commonSvgs.json'

const router = useRouter();
const svg_data = ref(commonSvgs);
const menu_icons = ref(menuIcons);
const editBetslipStore = EditBetSlip();
const oddsStore = useOddsStore();
const betslipStore = BetSlip();
const betBoosterStore = useBetBoosterStore();

const isBetBoostsRoute = computed(() => router.currentRoute.value.name === 'pre-sports-bet-boosts');

const price_up = ref(false);
const price_down = ref(false);

const props = defineProps({
	overview_market_header_name: {
		type: String,
		required: true,
	},
	overview_odd: {
		// type: Object,
		required: true,
	},
	needs_indicator: {
		type: Boolean,
		required: true,
	},
	fixture_id: {
		required: true,
	},
	odd_animation: {
		required: false,
		default: true,
	}
});

const boostedData = computed(() => {
	if (!isBetBoostsRoute.value || !props.overview_odd) return null;
	return betBoosterStore.getBoostedOddData(props.overview_odd);
});

const isOddSelected = computed(() => {
	if (!props.overview_odd) return false;
	if (boostedData.value) {
		return betslipStore.isBoostedOddInBetslip(props.overview_odd.uuid);
	}
	return (
		oddsStore.isOddInBetslip(props.overview_odd.uuid) ||
		oddsStore.isOddInEditBetslip(props.overview_odd.uuid)
	);
});

const addToBetslip = () => {
	if (!props.overview_odd || props.overview_odd.status == 'suspended') return;

	if (boostedData.value) {
		betslipStore.toggleToBetslip(
			{
				odd_uuid: props.overview_odd.uuid,
				fixture_id: props.fixture_id,
				campaign_id: boostedData.value.campaign_id || null,
			},
			null,
			null,
			true
		);
		return;
	}

	if (editBetslipStore.edit_mode_enabled) editBetslipStore.toggleToBetslip({ uuid: props.overview_odd.uuid, fixture_id: props.fixture_id })
	else betslipStore.toggleToBetslip({ odd_uuid: props.overview_odd.uuid, fixture_id: props.fixture_id })
};

if (props.odd_animation) {
	watch(() => props.overview_odd, (newOdd, oldOdd) => {
		if (newOdd == null || oldOdd == null) return;

		if (newOdd.status == 'suspended' || oldOdd.status == 'suspended') return;

		// If changed overview market from overview
		if (newOdd.uuid != oldOdd.uuid) return;

		if (newOdd.price > oldOdd.price) price_up.value = true;
		if (newOdd.price < oldOdd.price) price_down.value = true;

		setTimeout(() => {
			price_up.value = false;
			price_down.value = false;
		}, 5000);
	})
}
</script>

<template>
	<div @click="addToBetslip" class="betting-info-inner" :class="{'odd-selected': isOddSelected, 'has-boosted-price': Boolean(boostedData) }">
		<div class="desktop-bet">
			<div class="betting-info-main" :class="{'bet-up': price_up, ' bet-down': price_down, 'is-boosted-bet': Boolean(boostedData)}">
				<template v-if="overview_odd && !oddsStore.isOddSuspended(overview_odd)">
					<h6 v-if="needs_indicator && overview_odd.name_overview">{{ overview_odd.name_overview }}</h6>
					<template v-if="boostedData">
						<div class="boosted-price-display">
							<span class="original-odds">{{ oddsStore.oddsFormat(boostedData.original_odds) }}</span>
							<span class="arrow-sep">»</span>
							<span class="boosted-odds" :class="{ 'super-odd': boostedData.is_super_boost, 'standard-odd': !boostedData.is_super_boost }">
								{{ oddsStore.oddsFormat(boostedData.boosted_odds) }}
							</span>
						</div>
					</template>
					<h6 v-else> {{ oddsStore.oddsFormat(overview_odd.price) }} </h6>
				</template>
				<template v-else>
					<h6><svg class="locker-icon"
						xmlns="http://www.w3.org/2000/svg"
						xml:space="preserve"
						version="1.1"
						style="width:12; height:11; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
						viewBox="0 0 12 15.75"
						xmlns:xlink="http://www.w3.org/1999/xlink">
						<use :xlink:href="'/assets/images/odd-locker.svg#svg3108'" stroke-width="1px"  />
					</svg></h6>
				</template>
			</div>
		</div>

		<div class="mobile-bet">
			<div class="betting-info-main" :class="{'bet-up': price_up, ' bet-down': price_down, 'is-boosted-bet': Boolean(boostedData)}">
				<div class="betting-info-left">
					<h6 v-if="needs_indicator && overview_odd"> {{ props.overview_market_header_name  }} {{ '(' + overview_odd.name_overview   + ') ' }} </h6>
					<h6 v-else> {{ props.overview_market_header_name  }} </h6>
				</div>
				<div class="betting-info-right">
					<template v-if="overview_odd && !oddsStore.isOddSuspended(overview_odd)">
						<template v-if="boostedData">
							<div class="boosted-price-display">
								<span class="original-odds">{{ oddsStore.oddsFormat(boostedData.original_odds) }}</span>
								<span class="arrow-sep">»</span>
								<span class="boosted-odds" :class="{ 'super-odd': boostedData.is_super_boost, 'standard-odd': !boostedData.is_super_boost }">
									{{ oddsStore.oddsFormat(boostedData.boosted_odds) }}
								</span>
							</div>
						</template>
						<h6 v-else> {{ oddsStore.oddsFormat(overview_odd.price) }} </h6>
					</template>
					<template v-else>
					<h6><svg class="locker-icon"
						xmlns="http://www.w3.org/2000/svg"
						xml:space="preserve"
						version="1.1"
						style="width:12; height:11; shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
						viewBox="0 0 12 15.75"
						xmlns:xlink="http://www.w3.org/1999/xlink">
						<use :xlink:href="'/assets/images/odd-locker.svg#svg3108'" stroke-width="1px"  />
					</svg></h6>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
<style scoped>
.betting-info-inner {
	box-shadow: 0px 0px 2px rgba(12, 19, 26, 0.4);
}
.locker-icon{
	fill: var(--odd-color-text);
}
.betting-info-inner:hover .locker-icon {
	fill: var(--buttons-text-color);
}

.boosted-price-display {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	white-space: nowrap;
}

.original-odds {
	font-size: 11px;
	font-weight: 600;
	color: var(--dark-gray);
	text-decoration: line-through;
}

.arrow-sep {
	font-size: 11px;
	color: var(--dark-gray);
	font-weight: 700;
}

.boosted-odds {
	font-size: 12.5px;
	font-weight: 800;
}

.boosted-odds.super-odd {
	background: linear-gradient(135deg, var(--secondary) 0%, var(--odd-price-down) 100%);
	-webkit-background-clip: text;
	background-clip: text;
	-webkit-text-fill-color: transparent;
	color: var(--odd-price-down);
}

.boosted-odds.standard-odd {
	color: var(--primary);
	transition: color 0.2s ease;
}

.betting-info-inner:hover .boosted-odds.standard-odd {
	color: var(--secondary);
}

.betting-info-inner.odd-selected {
	background: var(--odd-selected-color, var(--primary)) !important;
}

.betting-info-inner.odd-selected .original-odds {
	color: var(--odd-selected-color-text, rgba(255, 255, 255, 0.7));
	opacity: 0.7;
}

.betting-info-inner.odd-selected .arrow-sep {
	color: var(--odd-selected-color-text, rgba(255, 255, 255, 0.85));
	opacity: 0.85;
}

.betting-info-inner.odd-selected .boosted-odds.standard-odd {
	color: var(--odd-selected-color-text, var(--secondary));
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
	.original-odds,
	.arrow-sep {
		display: none !important;
	}
}
</style>
